// 是否是对象
export var isObject = function (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
};
// 链接拼接参数
export function mergeParams(url, params) {
    var paramsStr = '';
    if (!url) {
        return '';
    }
    if (!isObject(params)) {
        return url;
    }
    var hashIndex = url.indexOf('#');
    var hashStr = hashIndex !== -1 ? url.slice(hashIndex) : '';
    url = url.split('#')[0];
    var originQuery = {};
    if (url.indexOf('?') === -1) {
        paramsStr = "".concat(url, "?");
    }
    else {
        paramsStr = "".concat(url.split('?')[0], "?");
        var queryArr = url.split('?')[1].split('&');
        queryArr.forEach(function (query) {
            if (query.includes('=')) {
                var key = query.split('=')[0];
                var value = query.split('=')[1];
                originQuery[key] = value;
            }
        });
    }
    for (var key in params) {
        if (key in originQuery) {
            delete originQuery[key];
        }
        if (params[key] !== undefined && params[key] !== null) {
            paramsStr = "".concat(paramsStr + key, "=").concat(params[key], "&");
        }
    }
    for (var key in originQuery) {
        paramsStr = "".concat(paramsStr + key, "=").concat(originQuery[key], "&");
    }
    paramsStr = paramsStr.substr(0, paramsStr.length - 1);
    return paramsStr + hashStr;
}
// 链接拼接hash参数
export function mergeHashParams(url, params) {
    var paramsStr = '';
    if (!url) {
        return '';
    }
    if (!isObject(params)) {
        return url;
    }
    var originHash = {};
    if (url.indexOf('#') === -1) {
        paramsStr = "".concat(url, "#");
    }
    else {
        paramsStr = "".concat(url.split('#')[0], "#");
        var hashArr = url.split('#')[1].split('&');
        hashArr.forEach(function (query) {
            if (query.includes('=')) {
                var key = query.split('=')[0];
                var value = query.split('=')[1];
                originHash[key] = value;
            }
        });
    }
    for (var key in params) {
        if (key in originHash) {
            delete originHash[key];
        }
        if (params[key] !== undefined && params[key] !== null) {
            paramsStr = "".concat(paramsStr + key, "=").concat(params[key], "&");
        }
    }
    for (var key in originHash) {
        paramsStr = "".concat(paramsStr + key, "=").concat(originHash[key], "&");
    }
    paramsStr = paramsStr.substr(0, paramsStr.length - 1);
    return paramsStr;
}
// 截取hash
export var parseHash = function () {
    var hashStr = location.hash;
    var pattern = /([^=&?#]+)=([^&#]*)/g;
    var matches = hashStr.match(pattern);
    if (!matches || !matches.length) {
        return {};
    }
    var hash = {};
    for (var index = 0; index < matches.length; index++) {
        var str = matches[index];
        var keyIndex = str.indexOf('=');
        hash[str.substr(0, keyIndex)] = decodeURIComponent(str.substr(keyIndex + 1));
    }
    return hash;
};
//# sourceMappingURL=urlQueryAndHash.js.map